import { BaseHelper } from 'services/BaseGraphQLAPIHelper';


export const getLLMConfigs = (afterCursor) => {
  const query = `query Llmconfigs {
    llmconfigs(first: 100, after:"${afterCursor}") {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          question
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({
    query,
    variables,
  });
};
